import * as React from "react"

//https://react-svgr.com/playground/
function SvgIconFacebook(props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25" {...props}>
            <circle cx={12.5} cy={12.5} r={12} fill="none" stroke="#fff" />
            <circle cx={21} cy={5} r={2.5} stroke="#fff" />
            <path
            d="M13 18v-5.5h1.8l.3-2.1H13V9c0-.6.2-1 1.1-1h1.1V6.1c-.2 0-.8-.1-1.6-.1-1.6 0-2.7 1-2.7 2.8v1.6H9v2.1h1.8V18H13z"
            fill="#fff"
            />
        </svg>
    )
}

export default SvgIconFacebook;
